import { SPB_CITY_CODE, SPB_CITY_NAME, TRegion } from '@/entities/regions'

import { API } from '@/shared/api/api-config'

export const syncApiRegion = (region?: TRegion | null): void => {
	const sourceRegion = region || {}
	const cityCode = sourceRegion.CITY_CODE || sourceRegion.REGION_CODE || SPB_CITY_CODE
	const cityName = sourceRegion.CITY_NAME || sourceRegion.REGION_NAME || SPB_CITY_NAME
	const cityNamePrepositional = sourceRegion.CITY_NAME_PREPOSITIONAL || sourceRegion.REGION_P_NAME || ''

	API.region = {
		...sourceRegion,
		CITY_CODE: cityCode,
		CITY_NAME: cityName,
		CITY_NAME_PREPOSITIONAL: cityNamePrepositional
	}
}
